<script>
export default {
  name: 'SectionTitle.vue',
  props: ["subtitle", "title", "anchor"],
  data() {
    return {};
  },
  methods: {},
  mounted() {

  }
};
</script>

<template>
  <div class="mb-4">
    <h5 :id="anchor" class="subtitle text-uppercase m-0" v-if="anchor">{{subtitle}}</h5>
    <h5 class="subtitle text-uppercase m-0" v-else>{{subtitle}}</h5>
    <h1 class="title text-white text-uppercase" v-html="title"></h1>
  </div>
</template>

<style scoped>
.title{
  font-family: "Sqwaredblack", sans-serif;
  font-size: 3.2em;
}
.subtitle{
  color:var(--main-color);
  font-family: "monument_extendedultrabold" !important;
}
@media (max-width: 575.98px){
  .title{
    font-size: 2.2em;
  }
}
@media (min-width: 576px) and (max-width: 767.98px){
  .title{
    font-size: 2.8em;
  }
}
</style>
